import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import ProjectCard from "./ProjectCards";
import cmdcraft from "../../Assets/Projects/cmdcraft.png"
import FunTracker from "../../Assets/Projects/FunTracker.png"
import mystreyMessage from "../../Assets/Projects/mystreyMessage.png"
import Youtube from "../../Assets/Projects/Youtube.png"
import aiTicket from "../../Assets/Projects/aiTicket.png"
import blog from "../../Assets/Projects/blog.png"

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={aiTicket}
              isBlog={false}
              title="Ai Ticket Assistant"
              description="The AI Ticket Assistant is a smart support ticket system that leverages an AI agent to streamline the resolution process. When a new ticket is created, the AI agent automatically analyzes its content and provides an intelligent, context-aware response to guide the support team."
              ghLink="https://github.com/Rudra2637/Ai-Ticket-Assistant"
              demoLink="https://ai-ticketwise.vercel.app/login"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Youtube}
              isBlog={false}
              title="Youtube Clone"
              description="A full-stack YouTube clone that allows users to upload, stream, and interact with videos. The application includes a robust Node.js + Express backend for handling video uploads, user authentication, and REST APIs, along with a responsive frontend that replicates the core YouTube experience."
              ghLink="https://github.com/Rudra2637/Youtube-Clone-"
              demoLink="https://mytube-clone.onrender.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={mystreyMessage}
              isBlog={false}
              title="Mystrey Message"
              description=" Mystery Message, a full-stack anonymous messaging application built with the Next.js, TypeScript, and Tailwind CSS. This platform allows users to create a unique profile and receive anonymous messages from anyone who has their link."
              ghLink="https://github.com/Rudra2637/Mystrey-Message"
              demoLink="https://mystrey-message-4fqn.vercel.app/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={cmdcraft}
              isBlog={false}
              title="CmdCraft"
              description=" CmdCraft is a versatile command-line tool that brings the power of AI to your terminal. It's designed to be a smart and efficient assistant for a variety of tasks, from technical queries to entertainment recommendations."
              ghLink="https://github.com/Rudra2637/cmdcraft"
              // demoLink=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={FunTracker}
              isBlog={false}
              title="Fun Tracker"
              description="Fun Tracker is a simple React-based web app that serves fun and random content including jokes, cat images, books, dog photos, and more — all fetched via public APIs. It’s designed to help beginners learn how to handle APIs, manage state (with Redux), and build interactive, responsive interfaces."
              ghLink="https://github.com/Rudra2637/Fun-Tracker-"
              demoLink="https://fun-tracker.vercel.app/" 
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={blog}
              isBlog={false}
              title="Mega Blog"
              description="A blog website using React and Appwrite supports creating, updating, deleting, and viewing posts. Appwrite manages authentication, database storage, and image uploads, while React handles the UI. Only logged-in users can create posts, and authors can edit or delete their own content."
              ghLink="https://github.com/Rudra2637/Mega-Blog"
              demoLink="https://mega-blog-zeta-wheat.vercel.app/"      
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
